/**
 * Leaderboard use cases – top lifts by exercise, optional date range.
 */
import { leaderboardRepo } from '../../data/repositories/LeaderboardRepository';

export async function getTopLifts(exercise, limitCount = 50, startDate = null, endDate = null) {
  return leaderboardRepo.getTopByExercise(exercise, limitCount, startDate, endDate);
}
